import { UserViewedQuoteRequestParams } from '@lio/api-types';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUserViewedQuote = () => {
  const client = useClient();
  const date = new Date().toISOString();

  const mutationFn = ({ quoteId, userId }: UserViewedQuoteRequestParams) =>
    client.put(`user/${userId}/viewed-quote/${quoteId}`, {
      json: {
        viewedAt: date,
      },
    });

  const result = useMutation({
    mutationFn,
  });
  return { ...result, userViewedQuoteAsync: result.mutateAsync };
};
